export { MigrationResourcesCard } from './migration-resources-card';
